import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Qrcode.tsx
const QrcodeIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1 12.9a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1H4l-.103-.005A1 1 0 0 1 3 20v-6.1a1 1 0 0 1 .897-.995L4 12.9h6.1ZM5 19h4.1v-4.1H5V19Z",
			fill: props.fill || "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.599 18.3a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM20.001 18.3a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM17.302 15.6a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM14.599 12.9a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM20.001 12.9a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7Z",
			fill: props.fill || "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1 3a1 1 0 0 1 1 1v6.1a1 1 0 0 1-1 1H4l-.103-.005A1 1 0 0 1 3 10.1V4a1 1 0 0 1 .897-.995L4 3h6.1ZM5 9.1h4.1V5H5v4.1ZM19.998 3a1 1 0 0 1 1 1v6.1a1 1 0 0 1-1 1h-6.1l-.102-.005a1 1 0 0 1-.898-.995V4a1 1 0 0 1 .898-.995L13.898 3h6.1Zm-5.1 6.1h4.1V5h-4.1v4.1Z",
			fill: props.fill || "currentColor"
		})
	]
}));
//#endregion
export { QrcodeIcon };
